module.exports = __webpack_public_path__ + "img/product.fcaa20f0.jpg";